export default __webpack_public_path__ + "static/media/partner_subrole_1.be79a38e.png";